import React, { useState, useRef } from "react";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import Quill from "quill";
import CustomSimpleDialog from "../../components/CustomDialog/CustomSimpleDialog";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { templatePlaceholders } from "./TemplatesModel";
import CustomInputValid from "../../components/CustomInput/CustomInputValid";
import { IconButton } from "@material-ui/core";
import Button from "../../components/CustomButtons/Button";
import { clone } from "lodash";

const formats = [
  'font', 'size',
  'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'script',
  'header', 'blockquote', 'code-block',
  'list', 'bullet', 'indent',
  'direction', 'align',
  'link', 'formula',
  'clean',
  'placeholder',
  'image'
];

function insertPlaceholder(quill, placeholderName) {
  const range = quill.getSelection(true);
  const Delta = Quill.import('delta');
  const placeholderDelta = new Delta()
    .retain(range.index)
    .insert({ placeholder: placeholderName });

  quill.updateContents(placeholderDelta, 'user');
  quill.setSelection(range.index + 1);
}

function insertImage(quill, imageUrl) {
  // Basic URL pattern check
  if (!/^https?:\/\/.+\.(jpg|jpeg|png|gif|webp|svg)$/.test(imageUrl)) {
    console.warn('🚫 Invalid image URL format:', imageUrl);
    return;
  }

  // Verify image actually loads
  const img = new Image();
  img.onload = () => {
    const range = quill.getSelection(true);
    if (range) {
      quill.insertEmbed(range.index, 'image', imageUrl, 'user');
      quill.setSelection(range.index + 1);
      console.log('✅ Image inserted:', imageUrl);
    }
  };
  img.onerror = () => {
    console.warn('❌ Failed to load image from URL:', imageUrl);
  };
  img.src = imageUrl;
}

const TemplateBlockDefault = props => {
    const { block, editingId, setEditingId, handleContentChange, handleContentChange2, removeBlock, addBlock, moveBlock, duplicateBlock, column } = props;
    const quillRef = useRef();
    const quillRef2 = useRef();

    const modules = {
        toolbar: {
            container: [
            [{ font: [] }, { size: [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            [{ script: 'super' }, { script: 'sub' }],
            [{ header: '1' }, { header: '2' }, 'blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }, { align: [] }],
            ['link', 'formula'],
            ['clean']
            ]
        }
    };

    const [selectVariable, setSelectVariable] = useState(false);
    const [selectedVariable, setSelectedVariable] = useState('');
    const [customValue, setCustomValue] = useState('');
    const [modifyStyle, setModifyStyle] = useState(false);
    const [blockStyle, setBlockStyle] = useState({});

    return <>
        {editingId === block.id ? (
                <div>
                    {modifyStyle && <CustomSimpleDialog 
                        open={true}
                        close={() => {
                            setModifyStyle(false);
                        }}
                        no_ok_button={true}
                        content={<>
                            <h4>Modify Block Style</h4>
                            <CustomInputValid 
                                value={blockStyle.border}
                                label="Border"
                                onChange={(e) => {
                                    const input = e.target.value;
                                    const blockClone = clone(blockStyle);
                                    blockClone.border = input;
                                    if (input) {
                                        blockClone.display = 'block';
                                    } else {
                                        blockClone.display = 'inline-block';
                                    }
                                    setBlockStyle(blockClone);
                                }}
                            />
                            <div><em>* e.g. "1px solid black"</em></div>
                            <CustomInputValid 
                                value={blockStyle.fontSize}
                                label="Font Size"
                                onChange={(e) => {
                                    const input = e.target.value;
                                    // Allow only digits or empty string
                                    if (/^(0|[1-9]\d*)?$/.test(input)) {
                                        const blockClone = clone(blockStyle);
                                        blockClone.fontSize = input;
                                        setBlockStyle(blockClone);
                                    }
                                }}
                            />
                            <CustomInputValid 
                                value={blockStyle.padding}
                                label="Padding"
                                onChange={(e) => {
                                    const input = e.target.value;
                                    // Allow only digits or empty string
                                    if (/^(0|[1-9]\d*)?$/.test(input)) {
                                        const blockClone = clone(blockStyle);
                                        blockClone.padding = input;
                                        setBlockStyle(blockClone);
                                    }
                                }}
                            />
                            <CustomSelect 
                                default={blockStyle.fontFamily}
                                options={['','Arial','Times New Roman']}
                                label="Select a Font Family"
                                choose={(chosen) => {
                                    const blockClone = clone(blockStyle);
                                    blockClone.fontFamily = chosen;
                                    setBlockStyle(blockClone);
                                }}
                            />
                            <Button color="primary" className="mr-20" onClick={() => {
                                const obj = {};
                                if (blockStyle.fontSize) {
                                    obj.fontSize = blockStyle.fontSize;
                                }
                                if (blockStyle.fontFamily) {
                                    obj.fontFamily = blockStyle.fontFamily;
                                }
                                if (props.column === 1 || !props.column) {
                                    handleContentChange(block.id, null, blockStyle);
                                } else {
                                    handleContentChange2(block.id, null, blockStyle);
                                }
                                setModifyStyle(false);
                            }}>
                                Submit
                            </Button>
                            <Button color="white" onClick={() => {
                                setBlockStyle({});
                                setModifyStyle(false);
                            }}>
                                Cancel
                            </Button>
                        </>}
                    />}

                    {selectVariable && <CustomSimpleDialog 
                        open={true}
                        close={() => {
                            setSelectVariable(false);
                        }}
                        no_ok_button={true}
                        content={<>
                            <h4>Select a Field</h4>
                            <CustomSelect 
                                options={props.templateType === 'ERTL' ? 
                                    ([{
                                        id: 'custom',
                                        desc: 'Custom Value'
                                    }]).concat(Object.keys(templatePlaceholders.ERTL).sort().map(field => {
                                        return {
                                            id: field,
                                            desc: `${templatePlaceholders.ERTL[field]} - ${field}`
                                        }
                                    }))
                                :
                                    ([{
                                        id: 'custom',
                                        desc: 'Custom Value'
                                    }]).concat(Object.keys(templatePlaceholders.PMA).sort().map(field => {
                                        return {
                                            id: field,
                                            desc: `${templatePlaceholders.PMA[field]} - ${field}`
                                        }
                                    }))
                                }
                                indx="id"
                                desc="desc"
                                label="Choose a field"
                                default={selectedVariable}
                                choose={(chosen) => {
                                    if (chosen) {
                                        if (chosen !== 'custom') {
                                            setSelectedVariable(chosen);
                                            if (props.column === 1 || !props.column) {
                                                insertPlaceholder(quillRef.current.getEditor(), chosen)
                                            } else {
                                                insertPlaceholder(quillRef2.current.getEditor(), chosen)
                                            }
                                            
                                            setSelectedVariable('');
                                            setCustomValue('');
                                            setSelectVariable(false);
                                        } else {
                                            setSelectedVariable(chosen);
                                        }
                                    }
                                }}
                            />

                            {selectedVariable === 'custom' && <CustomInputValid 
                                value={customValue}
                                placeholder="Custom Field Name"
                                onChange={(e) => {
                                    setCustomValue(e.target.value);
                                }}
                                autoFocus={true}
                                label="Enter Custom Field Name"
                            />}

                            {selectVariable && selectedVariable === 'custom' && <Button size="sm"
                                color="primary"
                                onClick={() => {
                                    if (customValue) {
                                        if (props.column === 1 || !props.column) {
                                            insertPlaceholder(quillRef.current.getEditor(), customValue);
                                        } else {
                                            insertPlaceholder(quillRef2.current.getEditor(), customValue);
                                        }
                                        
                                        setSelectedVariable('');
                                        setCustomValue('');
                                        setSelectVariable(false);
                                    }
                                }}
                            >
                                Insert custom field
                            </Button>}
                        </>}
                    />}

                    {!selectVariable && <Button size="sm"
                        color="primary"
                        onClick={() => {
                            setSelectVariable(true);
                        }}
                    >
                        Insert field
                    </Button>}

                    <Button size="sm" color="primary"
                        onClick={() => {
                            const imageUrl = prompt('Paste an image URL (https://...)');
                            if (imageUrl) {
                                if (props.column === 1 || !props.column) {
                                    insertImage(quillRef.current.getEditor(), imageUrl);
                                } else {
                                    insertImage(quillRef2.current.getEditor(), imageUrl);
                                }
                            }
                        }}
                        >
                        Insert Image
                    </Button>

                    {!column && <Button size="sm" color="success"
                        onClick={() => {
                            setModifyStyle(true);
                            if (block.style) setBlockStyle(block.style)
                        }}
                        >
                        Modify style
                    </Button>}

                    {/* {<Button size="sm" color="white"
                        onClick={() => {
                            duplicateBlock(block);
                        }}
                        >
                        Duplicate Block
                    </Button>} */}
                <ReactQuill
                    value={props.column === 1 || !props.column ? block.content : block.content2}
                    onChange={(value) => {
                        if (props.column === 1 || !props.column) {
                            handleContentChange(block.id, value)
                        } else {
                            handleContentChange2(block.id, value)
                        }
                    }}
                    formats={formats}
                    modules={modules}
                    ref={props.column === 1 || !props.column ? quillRef : quillRef2}
                />
                {!column && <div className="mt-2 flex justify-between">
                    <Button
                        size="sm"
                        color="primary"
                        className="mr-20"
                        onClick={() => setEditingId(null)}
                    >
                    Ok
                    </Button>
                    <Button
                        size="sm"
                        color="white"
                        className="mr-20"
                        onClick={() => {
                            setEditingId(null)
                        }}
                    >
                    Cancel
                    </Button>
                    <Button
                        size="sm"
                        color="danger"
                        className="mr-20"
                        onClick={() => removeBlock(block.id)}
                    >
                    Delete
                    </Button>
                    <Button
                        size="sm"
                        color="danger"
                        className="mr-20"
                        onClick={() => moveBlock(block.id, 'left')}
                    >
                        <i className="fa fa-arrow-left"></i>
                    </Button>
                    <Button
                        size="sm"
                        color="danger"
                        className="mr-20"
                        onClick={() => moveBlock(block.id, 'right')}
                    >
                        <i className="fa fa-arrow-right"></i>
                    </Button>
                </div>}
                </div>
            ) : (<>
                {!column && <span className="relative bordery" style={block.style ? block.style: {}}>
                    <span
                        className="hoverable-gray"
                        onClick={() => setEditingId(block.id)}
                        dangerouslySetInnerHTML={{ __html: block.content }}
                    />
                    <div style={{opacity:0}}
                        onClick={() => setEditingId(block.id)}
                    >content placeholder here so you can click on the section</div>
                    <div className="absolute-block">
                        <IconButton
                            onClick={() => addBlock(block.id)}
                        >
                            <i className="fa fa-plus-circle text-blue-600" />
                        </IconButton>
                    </div>
                </span>}

                {column && <span className="relative bordery" style={block.style ? block.style: {}}>
                    <GridContainer>
                        <GridItem xs={6} sm={6} md={6}>
                            <span
                                className="hoverable-gray"
                                onClick={() => setEditingId(block.id)}
                                dangerouslySetInnerHTML={{ __html: block.content }}
                            />
                            <div style={{opacity:0}}
                                onClick={() => setEditingId(block.id)}
                            >content placeholder here so you can click on the section</div>
                        </GridItem>
                        <GridItem xs={6} sm={6} md={6}>
                            <span
                                className="hoverable-gray"
                                onClick={() => setEditingId(block.id)}
                                dangerouslySetInnerHTML={{ __html: block.content2 }}
                            />
                            <div style={{opacity:0}}
                                onClick={() => setEditingId(block.id)}
                            >content placeholder here so you can click on the section</div>
                        </GridItem>
                    </GridContainer>
                </span>}
            </>
            )}
    </>
}

export default TemplateBlockDefault;